module.exports = __webpack_public_path__ + "24e473e5f326489364c68098a8610e9b.png";